export default __webpack_public_path__ + "static/media/contact.9eb00cc3.png";